<script>
import { mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { required } from 'vuelidate/lib/validators';

import { frontendUrl } from '@/config';
import languageToSlug from '@/helpers/languageToSlug';
import { StatusCodes as HTTP } from 'http-status-codes';
import SingleView from '@/components/elements/views/SingleView';
import AddEditForm from '@/components/article-categories/AddEditForm';
import SubcategoriesTable from '@/components/article-categories/SubcategoriesTable';

export default {
    page: {
        title: 'Manage Category'
    },

    components: {
        AddEditForm,
        SubcategoriesTable
    },

    extends: SingleView,

    validations: {
        item: {
            name: {
                required
            },
            slug: {
                required
            },
            description: {}
        },
        language: {
            id: {
                required
            }
        }
    },

    data() {
        const categoryContent = {
            hero: {
                image: null,
                mobileImage: null,
                limitWidth: true
            },
            introductionSection: {
                title: 'Title',
                description: '<p>Description</p>',
                buttons: [
                    {
                        title: 'Title',
                        description: 'Description',
                        image: null,
                        link: '/',
                        isHidden: false
                    }
                ]
            },
            moreInformation: {
                title: 'כדאי לדעת',
                items: []
            },
            videoSection: {
                youtube: null,
                title: 'Title',
                video: null
            }
        };

        return {
            backRoute: '/article-categories',
            indexName: 'Categories',
            singleItemName: 'category',
            languagePicker: true,
            meta: true,
            item: {
                parentCategoryId: null,
                meta: {},
                content: cloneDeep(categoryContent)
            }
        };
    },

    computed: {
        additionalFormComponents() {
            const subcategoriesComponent = {
                name: 'subcategories-table',
                props: {
                    categoryId: this.item.id
                }
            };

            const subcategoriesCondition = this.editMode && this.item.id;

            const components = subcategoriesCondition
                ? [subcategoriesComponent]
                : [];

            return components;
        },

        previewUrl() {
            const { language, slug, parentCategoryId } = this.item;

            const languageSlug = languageToSlug(language);

            const url = frontendUrl.concat(languageSlug);

            const type = parentCategoryId ? 'subcategories' : 'categories';

            return url.concat(`/${type}/${slug}`);
        },

        itemInformationOptions() {
            return {
                slugBasicUrl: this.item.parentCategoryId
                    ? 'subcategories'
                    : 'categories'
            };
        }
    },

    methods: {
        ...mapActions({
            addItem: 'articleCategories/store',
            deleteItem: 'articleCategories/destroy',
            getItem: 'articleCategories/show',
            updateItem: 'articleCategories/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const { addEditForm } = this.$refs;
            const { tabsSection } = addEditForm.$refs;

            if (tabsSection?.$v) {
                tabsSection.$v.$touch();

                if (tabsSection.$v.$invalid) {
                    return;
                }
            }

            const data = {
                ...this.item,
                ...this.additionalStoreData
            };

            if (this.languagePicker) {
                data.languageId = this.language.id;
            }

            try {
                if (!this.editMode) {
                    const added = await this.addItem(data);

                    this.$router.push(
                        this.constructStoreActionBackRoute(added)
                    );
                } else {
                    const { updatedAt, tabs } = await this.updateItem({
                        id: this.id,
                        data
                    });

                    this.item.updatedAt = updatedAt;
                    this.item.language = this.language;
                    this.item.tabs = tabs;
                    this.itemValueStringify = JSON.stringify(this.item);

                    this.$toaster('Item updated!');
                }
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
